import React from 'react';
import { connect } from 'react-redux';
import { REDUCER_NAME, toggleSaveLayoutPopup, saveLayout } from './../reducer';
import { compose } from 'redux';
import SimpleTooltip from '../../../common/tooltip/SimpleTooltip';
import Popout from '../../../helpers/Popout';
import Layout from '../../../helpers/Layout';
import LockedDiv from '../../../common/locked-div/LockedDiv';

class SaveLayout extends React.Component {
  doSomethingBeforeUnload = () => {
    const { saveLayout } = this.props;
    this.closeAllPopout();
    saveLayout();
  };

  closeAllPopout = () => {
    Layout.layout.openPopouts.forEach(popout => {
      popout._popoutWindow.close();
    });
    const popouts = Object.values(Popout.getAll());
    popouts.forEach(popout => {
      popout._popoutWindow.close();
    });
  };

  setupBeforeUnloadListener = () => {
    window.addEventListener('beforeunload', ev => {
      ev.preventDefault();
      return this.doSomethingBeforeUnload();
    });
  };

  componentDidMount() {
    this.setupBeforeUnloadListener();
  }

  save = () => {
    const { toggleSaveLayoutPopup } = this.props;
    toggleSaveLayoutPopup();
  };

  render() {
    return (
      <LockedDiv allowExpired>
        <li onClick={this.save}>
          <SimpleTooltip
            message="layout.tooltipSideBar.SAVE_CURRENT_WORKSPACE"
            position="right"
            isI18n={true}
            appendClassName="d-block"
            appendStyle={{ zIndex: 99999 }}
          >
            <a href="#">
              <i className="icon-save" />
            </a>
          </SimpleTooltip>
        </li>
      </LockedDiv>
    );
  }
}

const mapStateToProps = state => {
  return {
    state,
    isShowPopup: state[REDUCER_NAME].saveLayout.isShowPopup,
    userInfo: state.userInfo,
  };
};

const mapDispatchToProps = {
  toggleSaveLayoutPopup,
  saveLayout,
};

export default compose(
  connect(
    mapStateToProps,
    mapDispatchToProps,
  ),
)(SaveLayout);
